package net.sergeych.parsec3

import kotlinx.browser.localStorage


@Suppress("unused")
actual fun defaultNamedStorage(name: String): KVStorage = BrowserKVStorage(name, localStorage)